import { useCallback, useContext, useRef } from 'react';

import LanguageContext from './LanguageContext.js';

// TODO: These imports should be in dollhouse-booking once it's available
/*
import af from 'date-fns/locale/af';
import ar from 'date-fns/locale/ar';
import ca from 'date-fns/locale/ca';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import lt from 'date-fns/locale/lt';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import ro from 'date-fns/locale/ro';
import ru from 'date-fns/locale/ru';
import sk from 'date-fns/locale/sk';
import uk from 'date-fns/locale/uk';
import vi from 'date-fns/locale/vi';
import zh from 'date-fns/locale/zh-CN';
import { registerLocale } from 'react-datepicker'; */

export enum AvailableLanguages {
  en = 'English',
  es = 'Español',
  de = 'Deutsch',
  fr = 'Français',
  it = 'Italiano',
  pt = 'Português',
  // ro = 'ro',
  // zh = 'zh',
  // ja = 'ja',
  // ar = 'ar',
  // ru = 'ru',
  // pl = 'pl',
  // ca = 'ca',
  // af = 'af',
  // ko = 'ko',
  // lt = 'lt',
  // uk = 'uk',
  // vi = 'vi',
}

/* TODO: Move to dollhouse-booking package
registerLocale('de', de);
registerLocale('es', es);
registerLocale('fr', fr);
registerLocale('it', it);
registerLocale('pt', pt);
registerLocale('ro', ro);
registerLocale('ru', ru);
registerLocale('sk', sk);
registerLocale('zh', zh);
registerLocale('ja', ja);
registerLocale('ar', ar);
registerLocale('pl', pl);
registerLocale('ca', ca);
registerLocale('af', af);
registerLocale('ko', ko);
registerLocale('lt', lt);
registerLocale('uk', uk);
registerLocale('vi', vi);
*/
export const isAvailableLanguage = (lang: string) => {
  return new RegExp(/^\w{2}$/).test(lang);
};
export const getLanguageFromUrl = (pathname: string) => {
  const [, lang] = pathname.split(/\/+/);
  const isLang = isAvailableLanguage(lang);
  return isLang ? (lang as string) : null;
};

export const formatPath = (pathname: string, search?: string, hash?: string) => {
  return `${pathname}${search ?? ''}${hash ?? ''}`;
};

export const formatLocalizedPathname = (pathname: string, locale: string | null) => {
  const [, ...rest] = pathname.split(/\/+/);
  const localeInPath = getLanguageFromUrl(pathname);

  if (localeInPath) {
    rest.shift();
  }

  return locale ? [`/${locale}`, ...rest].join('/') : `/${rest.join('/')}`;
};

/**
 * Hook to get the current language
 */
export const useLanguage = () => {
  const {
    setLocale: setStateLocale = () => {
      console.warn('useLanguage: Not refreshing due not provider detected');
    },
    defaultLocale: ctxDefaultLocale,
    locale: stateLocale,
    locales,
  } = useContext(LanguageContext) ?? {};

  let defaultLocale = ctxDefaultLocale ?? 'en';

  if (ctxDefaultLocale) {
    const [language] = ctxDefaultLocale.split('-');
    if (Object.keys(AvailableLanguages).includes(language)) {
      defaultLocale = language as string;
    }
  }

  let location: Location = window.location;

  const { pathname } = location;
  const localeInPath = getLanguageFromUrl(pathname);
  const languageRef = useRef<'auto' | string>('auto');
  const localeRef = useRef(defaultLocale);

  if (localeInPath) {
    languageRef.current = localeInPath;
    localeRef.current = localeInPath;
  } else {
    languageRef.current = 'auto';
    localeRef.current = stateLocale ?? defaultLocale;
  }
  // setLanguage
  const setLocale = useCallback(
    (locale: string | null) => {
      // Set del store que cambia el language
      setStateLocale(locale);
    },
    [setStateLocale]
  );

  return {
    language: languageRef.current,
    locale: localeRef.current,
    locales,
    languages: AvailableLanguages,
    setLocale,
  };
};

export default useLanguage;
